import React from 'react';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { TertiaryButton } from '@grnhse/seedling/lib/birch/components/buttons';
import {
  AdvancedFilters,
  ApplicationFiltersGroup,
  CandidateFiltersGroup,
  Fraud,
  Keywords,
  SavedForLater,
} from 'talent_matching/components/filters';
import { useFormContext } from '@grnhse/seedling/lib/birch/components/forms/form';
import { useUserContext } from 'talent_matching/contexts/user_context';
import { withLocalePrefix } from 'shared/utils/translation';
import AppliedFiltersRow from 'talent_matching/components/applied_filters/applied_filters_row';
import { FORM_DEFAULTS } from 'talent_matching/components/filter_form';
import SavedFilters from 'talent_matching/components/filters/saved_filters';
import styled from 'styled-components';

const t = withLocalePrefix('talent_matching.filter_row.buttons');

const NoWrap = styled(Stack)`
  white-space: nowrap;
`;

const FilterRow = () => {
  const { reset } = useFormContext();
  const { canUseFraudFilter } = useUserContext();

  const handleClearAll = () => {
    reset(FORM_DEFAULTS);
  };

  return (
    <Stack spacing={0}>
      <Stack direction="row" justifyContent="space-between">
        <NoWrap spacing={1} direction="row" alignItems="center" flexWrap="wrap">
          <SavedForLater />
          {canUseFraudFilter && <Fraud />}
          <ApplicationFiltersGroup />
          <CandidateFiltersGroup />
          <Keywords />
          <AdvancedFilters />
          <TertiaryButton size="md" onClick={handleClearAll}>
            {t('clear_all')}
          </TertiaryButton>
        </NoWrap>
        <SavedFilters onClearAll={handleClearAll} />
      </Stack>
      <AppliedFiltersRow />
    </Stack>
  );
};

export default FilterRow;
